import styled from "styled-components";
import { FancyTitle } from "./components/fancyTitle";
import { useNuovoRistoranteQuery } from "../../generated/graphql";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  width: 100%;
  justify-content: center;
  box-sizing: border-box;
  padding: 40px 100px;
  p {
    margin: 0;
    padding: 0;

    display: block;
  }
  @media screen and (max-width: 900px) {
    padding: 20px 20px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    text-align: justify;
  }
`;
const Text = styled.div`
  flex: 1;
  max-width: 600px;
`;

export function Filosofy() {
  const { data } = useNuovoRistoranteQuery();
  return (
    <Container>
      <meta
        name='description'
        content={documentToReactComponents(
          data?.nuovoRistorante?.primoTesto?.json
        )?.toString()}
      />
      <div>
        <FancyTitle text={data?.nuovoRistorante?.primoTitolo || ""} />
      </div>
      <Text>
        <p>
          {documentToReactComponents(data?.nuovoRistorante?.primoTesto?.json)}
        </p>
      </Text>
    </Container>
  );
}
//
